/* Alpacas Foods — quantidade da PDP (stepper OU faixas por quantidade) + total.
   Porta a lógica de qty do PDP.tsx. Sem faixas, o comportamento é o de sempre.
   Desenvolvido por Hogrid — https://hogrid.com */

/* Formata centavos com o money_format da própria loja (recebido via
   data-money-format), para não divergir do filtro `money` do Liquid quando a
   loja troca separador, símbolo ou moeda do mercado. Sem formato utilizável,
   cai no locale do navegador. */
function alpFormatMoney(cents, format) {
  function group(value, thousands, decimal, places) {
    var parts = (value / 100).toFixed(places).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return places > 0 ? int + decimal + parts[1] : int;
  }
  var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
  if (!match) return (cents / 100).toLocaleString();
  var value;
  switch (match[1]) {
    case 'amount_no_decimals':                      value = group(cents, ',', '.', 0); break;
    case 'amount_with_comma_separator':             value = group(cents, '.', ',', 2); break;
    case 'amount_no_decimals_with_comma_separator': value = group(cents, '.', ',', 0); break;
    case 'amount_with_apostrophe_separator':        value = group(cents, "'", '.', 2); break;
    case 'amount_with_space_separator':             value = group(cents, ' ', ',', 2); break;
    case 'amount_no_decimals_with_space_separator': value = group(cents, ' ', ',', 0); break;
    default:                                        value = group(cents, ',', '.', 2); break;
  }
  return format.replace(match[0], value);
}

/* A guarda de `customElements` permite carregar este arquivo no Node para
   testar alpFormatMoney sem tocar no DOM. No browser nada muda. */
if (typeof customElements !== 'undefined' && !customElements.get('product-buy')) {
  customElements.define('product-buy', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      this.dec = this.querySelector('[data-qty-dec]');
      this.inc = this.querySelector('[data-qty-inc]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      // [data-buy-*] ficam fora do elemento (CTA fixo mobile).
      this.totals = Array.from(this.querySelectorAll('[data-total]'))
        .concat(Array.from(document.querySelectorAll('[data-buy-total]')));
      this.qtyOut = Array.from(document.querySelectorAll('[data-buy-qty]'));
      this.unit = parseInt(this.dataset.unitPrice, 10) || 0; // em centavos
      this.max = parseInt(this.dataset.max, 10) || 20;
      this.moneyFormat = this.dataset.moneyFormat || '';

      if (this.dec) this.dec.addEventListener('click', function () { this.step(-1); }.bind(this));
      if (this.inc) this.inc.addEventListener('click', function () { this.step(1); }.bind(this));
      if (this.input) this.input.addEventListener('change', this.render.bind(this));
      if (this.tiers.length) {
        this.addEventListener('change', function (e) {
          if (!e.target.hasAttribute || !e.target.hasAttribute('data-tier')) return;
          this.tiers.forEach(function (t) {
            var card = t.closest('.alp-pack');
            if (card) card.classList.toggle('is-on', t.checked);
          });
          this.render();
        }.bind(this));
      }
      this.render();
    }
    checked() { return this.tiers.filter(function (t) { return t.checked; })[0] || null; }
    /* Preço unitário já com desconto, calculado no Liquid pelo snippet
       alp-qty-tiers. O JS não replica a fórmula — só multiplica. */
    unitNet() {
      var t = this.checked();
      if (t && t.dataset.tierUnit) return parseInt(t.dataset.tierUnit, 10) || this.unit;
      return this.unit;
    }
    qty() {
      var t = this.checked();
      if (t) return parseInt(t.value, 10) || 1;
      if (!this.input) return 1;
      return Math.max(1, Math.min(this.max, parseInt(this.input.value, 10) || 1));
    }
    step(d) { if (!this.input) return; this.input.value = this.qty() + d; this.render(); }
    render() {
      var q = this.qty();
      if (this.input) this.input.value = q;
      if (this.dec) this.dec.disabled = q <= 1;
      var live = this.querySelector('[data-qty-live]');
      if (live) live.textContent = q;
      var cents = this.unitNet() * q;
      var formatted = alpFormatMoney(cents, this.moneyFormat);
      this.totals.forEach(function (el) { el.textContent = formatted; });
      this.qtyOut.forEach(function (el) { el.textContent = q; });
    }
  });
}

/* Exportação só para os testes em tests/ — ignorada pelo browser. */
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { alpFormatMoney: alpFormatMoney };
}
